import { callApi } from './api'
import { SERVICE } from './schemas'
import { serviceTypes } from '@src/globals'

export function create (userId, service) {
  const endpoint = `users/${userId}/services`
  const newService = prepareServiceForCreation(service, userId)

  const config = {
    method: 'POST',
    body: newService,
    requiresAuth: true
  }
  return callApi(endpoint, config)
}

export function fetch (userId, serviceId) {
  const endpoint = `users/${userId}/services/${serviceId}`
  const config = {
    method: 'GET',
    requiresAuth: true
  }

  return callApi(endpoint, config, SERVICE)
}

export function update (userId, serviceId, serviceChange) {
  const endpoint = `users/${userId}/services/${serviceId}`
  const config = {
    method: 'PUT',
    body: serviceChange,
    requiresAuth: true
  }

  return callApi(endpoint, config)
}

export function cancel (userId, serviceId) {
  const endpoint = `users/${userId}/services/${serviceId}/cancel`
  const config = {
    method: 'POST',
    requiresAuth: true
  }

  return callApi(endpoint, config)
}

export function fetchPenalty (userId, serviceId, serviceChange, method) {
  const endpoint = `users/${userId}/services/${serviceId}/penalty`
  const config = {
    method,
    requiresAuth: true
  }

  if (serviceChange) {
    config.body = serviceChange
  }

  return callApi(endpoint, config)
}

// FIXME(Richard Kaufman): This function shouldn't exist. Our service state should ALWAYS be ready to be sent for creation
export function prepareServiceForCreation (service, userId) {
  const valueOrUndefined = x => x || undefined

  const {
    service: serviceInfo,
    user,
    promoCode,
    paymentTokens
  } = service

  const result = {}
  const newService = {}

  newService.service_type_id = serviceInfo.serviceTypeId
  newService.estimated_hours = serviceInfo.estimatedHours
  newService.aliada_id = serviceInfo.aliadaId
  newService.date = serviceInfo.date
  newService.time = serviceInfo.time
  newService.special_instructions = serviceInfo.instructions
  newService.promotional_code = promoCode.code || ''
  newService.address = {
    street: valueOrUndefined(serviceInfo.address.street),
    number: valueOrUndefined(serviceInfo.address.number),
    interiorNumber: valueOrUndefined(serviceInfo.address.interiorNumber),
    colony: valueOrUndefined(serviceInfo.address.neighborhood),
    city: valueOrUndefined(serviceInfo.address.city),
    state: valueOrUndefined(serviceInfo.address.state),
    postalCodeNumber: valueOrUndefined(serviceInfo.address.postal_code_number),
    latitude: valueOrUndefined(serviceInfo.address.lat),
    longitude: valueOrUndefined(serviceInfo.address.lng)
  }

  if ((serviceInfo.serviceTypeId === serviceTypes.MULTIPLE.id) && serviceInfo.weekdays && (serviceInfo.weekdays.length > 0)) {
    newService.weekdays = serviceInfo.weekdays
  }

  const addressHasDefinedProps = Object.keys(newService.address).filter(prop => newService.address[prop]).length > 0
  if (!addressHasDefinedProps) {
    delete newService.address
  }

  newService.settings = serviceInfo.settings

  const userHasDefinedProps = Object.keys(user).length > 0
  if (userHasDefinedProps) {
    newService.user = user
  }

  result.service = newService

  if (paymentTokens.conekta_temporary_token) {
    result.conekta_temporary_token = paymentTokens.conekta_temporary_token
  }

  if (paymentTokens.stripe_temporary_token) {
    result.stripe_temporary_token = paymentTokens.stripe_temporary_token
  }

  result.user_id = userId

  return result
}

export function backgroundJob (uuid) {
  const endpoint = `background_jobs/${uuid}`
  const config = {
    requiresAuth: true
  }

  return new Promise(function (resolve, reject) {
    const intervalTimeInMilliseconds = 1500
    const intervalId = setInterval(() => {
      callApi(endpoint, config).then(
        ({ response }) => {
          if (response.jobStatus === 'failed') {
            clearInterval(intervalId)
            reject({ error: 'Error creating service' })
          } else if (response.jobStatus === 'completed') {
            clearInterval(intervalId)
            resolve(response)
          }
        }
      ).catch(
        (error) => {
          clearInterval(intervalId)
          reject(error)
        }
      )
    }, intervalTimeInMilliseconds)
  })
}



// WEBPACK FOOTER //
// ./src/services/api/services.js